import { marked } from './marked'
import Purifier from './dompurify'

export const parse = (text) => {
  return marked(Purifier.sanitize(text))
}
